import React from 'react';

const Badge = ({ number = 0, size = 40 }) => {
  const circleSize = size;
  const fontSize = size * 0.5;

  // Determine background color
  const getColor = (num) => {
    switch (num) {
      case 1:
        return '#FFD700'; // Gold
      case 2:
        return '#C0C0C0'; // Silver
      case 3:
        return '#CD7F32'; // Bronze
      default:
        return '#AAAAAA'; // Default gray
    }
  };

  return (
    <div
      className="flex items-center justify-center rounded-full shadow-lg border-2 border-white"
      style={{
        width: circleSize,
        height: circleSize,
        backgroundColor: getColor(number),
      }}
    >
      <span
        className="text-white font-bold"
        style={{ fontSize: fontSize }}
      >
        {number}
      </span>
    </div>
  );
};

export default Badge;
